





















import { Component, Prop, Vue } from 'vue-property-decorator';
import CloseButton from '@/components/Buttons/CloseButton.vue';
import BackButton from '@/components/Buttons/BackButton.vue';

@Component({
    components: {
        CloseButton,
        BackButton,
    },
})
export default class Modal extends Vue {
    @Prop({ default: true }) public withHeader: boolean;
    @Prop({ default: true }) public withFooter: boolean;
    @Prop({ default: '' }) public bodyId: string;

    constructor() {
        super();
    }
}
